module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-result-warp column"
  }, [_c('div', {
    staticClass: "game-result-header"
  }, [_c('div', {
    staticClass: "my-btn",
    on: {
      "click": function($event) {
        return _vm.toMy()
      }
    }
  }, [_vm._v("マイページへ")]), _vm._v(" "), _c('div', {
    staticClass: "my-topic"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.2rem",
      "margin-right": "1rem"
    }
  }, [_vm._v("テーマ:")]), _c('span', {
    staticClass: "my-topic-theme"
  }, [_vm._v(_vm._s(_vm.room.theme))])]), _vm._v(" "), _c('div', {
    staticClass: "title-box column column-center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("結果")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("プレイ時間：" + _vm._s(_vm.timeStr))])])]), _vm._v(" "), _c('div', {
    staticClass: "game-result-info-box column"
  }, _vm._l((_vm.users), function(item, index) {
    return _c('div', {
      staticClass: "item row m-column"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('div', {
      staticClass: "tig"
    }, [_vm._v("\n            " + _vm._s(item.tag == "房主" ? "ファシリテーター" : "プレイヤー") + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nickname))])]), _vm._v(" "), _c('div', {
      staticClass: "cards-lists row-flex row"
    }, _vm._l((item.cards), function(item2, index2) {
      return _c('el-image', {
        key: index2,
        staticClass: "card",
        attrs: {
          "src": item2.url,
          "fit": "contain"
        }
      })
    }), 1)])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42e10945"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/game/Result.vue
// module id = 887
// module chunks = 1